import { lightPalette } from '../../palette/light';
import { unifiedLightPageTheme } from './unifiedLightPageTheme';
import { UnifiedBaseTypography } from '../UnifiedBaseTypography';
import {
  createUnifiedTheme,
  createBaseThemeOptions,
} from '@dewise-devex/backstage-plugin-mui-uikit-react';
import { components } from '../components';

/**
 * Configures a light theme for the application using custom palette, typography,
 * and component overrides.
 *
 * - `createBaseThemeOptions` initializes foundational options like palette and typography.
 * - `createUnifiedTheme` extends these base options, incorporating page themes.
 *
 * @category Theming
 */
export const unifiedLightTheme = createUnifiedTheme({
  mode: 'light',
  // Establish base theme options, including color palette and typography settings
  ...createBaseThemeOptions({
    palette: lightPalette, // Custom light-mode palette settings
    typography: UnifiedBaseTypography, // Sets typography options, using Rubik font styles
    defaultPageTheme: 'home', // Default page theme set to 'home'
  }),

  // Sets the default theme for pages that don't specify a theme
  defaultPageTheme: 'home',

  // Ensures Rubik font is consistently applied across the application
  fontFamily: 'Rubik',

  // Defines themes for various pages, setting header colors and shapes
  pageTheme: unifiedLightPageTheme,

  components,
});
